import Text from '@components/ui-old/text';
import Link from '@components/ui-old/link';
import { useTranslation } from 'next-i18next';
interface Props {
  sectionHeading: string;
  categorySlug?: string;
  className?: string;
  textClassName?: string;
}
const SectionHeader: React.FC<Props> = ({
  sectionHeading = 'text-section-title',
  categorySlug,
  className = 'pb-0.5 mb-4 md:mb-5 lg:mb-6 2xl:mb-7 3xl:mb-8',
  textClassName = ''
}) => {
  const {
    t
  } = useTranslation('common');
  return <div className={`flex items-center justify-between -mt-2 ${className}`} data-sentry-component="SectionHeader" data-sentry-source-file="section-header.tsx">
      <Text className={`${textClassName} dark:text-neutral-200`} variant='mediumHeading' data-sentry-element="Text" data-sentry-source-file="section-header.tsx">
        {t(`${sectionHeading}`)}
      </Text>
      {categorySlug && <Link href={categorySlug} className='text-xs lg:text-sm xl:text-base xl:dark:text-neutral-200 text-heading dark:text-neutral-200 mt-0.5 lg:mt-1'>
          {t('text-see-all-product')}
        </Link>}
    </div>;
};
export default SectionHeader;